class MemberGroupMembersDatatable {
    constructor(vpnUserGroupID = null, numberOfMembers = 0, memberDatatable, modal){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.organizationID = organizationID;
        this.vpnUserGroupID = vpnUserGroupID;
        this.numberOfMembers = numberOfMembers;
        this.modal = modal;
        this.datatable = this.init(memberDatatable);
        this.initActions(organizationID);
    }
    init(memberDatatable){
        const thisClass = this;
        let data = {
            organizationID: thisClass.organizationID
        }
        if(this.vpnUserGroupID){
            data.vpnUserGroupID = this.vpnUserGroupID;
        }
        let datatableEl = $(memberDatatable);
        if ($.fn.DataTable.isDataTable(memberDatatable)) {
            datatableEl.DataTable().destroy();
        }
        let datatable = datatableEl.DataTable({
            searchDelay: 500,
            processing: false,
            serverSide: false,
            stateSave: false,
            sortable: false,
            info: false,
            ordering: false,
            paging: false,
            ajax: {
                url: '/team-members/?do=getMemberGroupMembers',
                type: 'POST',
                data: data
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: ''
            },
            language: {
                emptyTable:
                    "<div class='text-center min-h-200px d-flex flex-center flex-column'>" +
                    "   <i class=\"fa-solid fa-user-group fs-5hx ga-text-primary-500 mb-5\" aria-hidden=\"true\"></i>\n" +
                    "   <p class=\"text-primary fs-7 text-center mb-0\">\n" +
                    "       Your Team has no Members. \n" +
                    "   </p>" +
                    "</div>",
                loadingRecords: ""
            },
            drawCallback: function (settings) {
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(thisClass.modal.querySelectorAll('#member-group-members-datatable [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                /** Remove header of table */
                $(thisClass.modal).find("#member-group-members-datatable_wrapper .dataTables_scrollHead, #member-group-members-datatable_wrapper thead").hide();

                /** Set rows to section (members) */
                const api = this.api();
                const rows = api.rows({
                    page: "current"
                }).nodes();
                if (rows.length > 0) {
                    $(rows).eq(0).before(
                        "<tr class=\"section fs-5 fw-bolder border-0\" data-section-name=\"members\">" +
                        "   <td class=\"py-1 d-none\"></td>" +
                        "   <td class=\"py-1\"> Members" +
                        "       <span class=\"badge badge-sm badge-light-primary align-middle ms-1\">" +
                        "           <span id=\"member_group_members_selected\">" + thisClass.numberOfMembers + "</span>" +
                        "       </span>" +
                        "   </td>" +
                        "   <td class=\"py-1 text-end\">" +
                        "       <span class=\"text-decoration-underline-ga text-danger danger fs-7 remove-all-members-from-group\">Remove All</span>" +
                        "   </td>" +
                        "</tr>"
                    );
                }
            },
            createdRow: function (row, data) {
                if (!data.checked) {
                    $(row).addClass('d-none not-in-group');
                }
            },
            columns: [
                {
                    data: 'uuid',
                    className: 'py-2 d-none',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">' +
                            '    <input class="form-check-input cursor-pointer" type="checkbox" name="members[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                            '</div>';
                    }
                },
                {
                    data: 'name',
                    title: 'Member',
                    sortable: false,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row).generateTableMember();
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    className: 'text-end',
                    render: function (data, type, row) {
                        return '<span class="text-decoration-underline-ga text-danger danger fs-7 remove-member-from-group">Remove</span>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $(thisClass.modal).find('div[data-kt-docs-table-toolbar="base"]').addClass('d-none');
            } else {
                let numberOfSelectedMembers = $(thisClass.modal).find('#member-group-members-datatable tbody tr:not(.not-in-group, .d-none, .section)').length;
                if (numberOfSelectedMembers === 0) {
                    $(thisClass.modal).find('#member-group-members-datatable_wrapper').hide();
                    $(thisClass.modal).find('#member-group-members-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
                    $(thisClass.modal).find('#member-group-members-datatable_wrapper [data-kt-docs-table-filter="search-parent"]').addClass('d-none');
                }
            }
        });
        return datatable;
    }
    initActions(){
        const thisClass = this;
        /** Search */
        let timer;
        const input = thisClass.modal.querySelector('input[data-kt-docs-table-filter=search]');
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.searchDatatable(this.value.toLowerCase());
                }, 300);
            });
        }
    }
    searchDatatable(value) {
        /** Search only visible (selected) members */
        let data = this.datatable.rows().data().toArray();
        let membersInMemberGroup = 0;
        for(let i in data){
            let node = $(this.datatable.row(i).node());
            if(!node.hasClass('not-in-group')){
                if(value === '' || this.includeValue(data[i].name, value) || this.includeValue(data[i].username, value)){
                    node.removeClass('d-none');
                    membersInMemberGroup++;
                } else {
                    node.addClass('d-none');
                }
            }
        }

        if(membersInMemberGroup === 0){
            $(this.modal).find('#member-group-members-datatable_wrapper [data-section-name="members"]').addClass('d-none');
            $(this.modal).find('#member-group-members-datatable_no-search-results').removeClass('d-none');
        } else {
            $(this.modal).find('#member-group-members-datatable_wrapper [data-section-name="members"]').removeClass('d-none');
            $(this.modal).find('#member-group-members-datatable_no-search-results').addClass('d-none');
        }
    }
    includeValue(value, search) {
        if(value !== '' && value !== null){
            return value.toLowerCase().includes(search);
        }
        return false;
    }
    resetDatatable(){
        let addMembersToMemberGroupButton = this.modal.querySelector('#addMembersToMemberGroup');
        addMembersToMemberGroupButton.removeAttribute('disabled');
        
        let membersInMemberGroup = this.datatable.rows(':not(.not-in-group.d-none)').data().toArray();
        for(let i in membersInMemberGroup){
            let node = $(this.datatable.row(i).node());
            node.find('input[name=members\\[\\]]').prop('checked', false);
            node.addClass('d-none not-in-group');
        }

        let jQueryModal = $(this.modal);
        jQueryModal.find('#member-group-members-datatable_wrapper').hide();
        jQueryModal.find('#member-group-members-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
    }
}
window.MemberGroupMembersDatatable = MemberGroupMembersDatatable;